import { render, staticRenderFns } from "./GooglePlayStore.vue?vue&type=template&id=5ea1e66c&"
import script from "./GooglePlayStore.vue?vue&type=script&lang=ts&"
export * from "./GooglePlayStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports